import i18n from './index'

/**
 * Translate from outside React (T-023).
 *
 * The API service modules and the error classifier are plain functions, not
 * components, so they cannot call useTranslation. They still produce text that
 * a person reads, and that text has to be translatable.
 *
 * A thin wrapper rather than importing i18n everywhere for two reasons: the
 * call sites read the same as they do inside a component, and if the i18n
 * instance is ever swapped or lazily initialised, one file changes instead of
 * twenty.
 *
 * @param {string} key
 * @param {object} [values]  interpolation, e.g. { name: 'Rahim' }
 * @returns {string}
 */
export function t(key, values) {
    return i18n.t(key, values)
}

export default t
